import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
import LoadingOverlay from 'framework-asset-preview-lib/internal/shared/components/LoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
export default Loadable({
  loader: () => import( /* webpackChunkName: "cta-preview-card" */'./CtaPreviewCard').then(mod => mod.default).catch(AsyncComponentErrorHandler('cta-preview-card')),
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingOverlay, {
    previewType: "card"
  })
});